export default {
    id: 'gray',
    colors: ['#EAEAEA', '#595959'],
};
